import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import ButtonOutlined from '@design-system/ButtonOutlined';
import IconError from '@experimental-components/IconsComponents/ErrorIllustration';
import SuccessIllustration from '@experimental-components/IconsComponents/SuccessIllustration';

import useStyles from './styles';

function DialogMessage({ open, onClose, type, textTitle, textDescription, children, notification }) {
  const { t } = useTranslation();
  const classes = useStyles();

  function renderIconStatus() {
    if (type === 'success') {
      return <SuccessIllustration size={48} />;
    }

    if (type === 'error') {
      return <IconError size={48} />;
    }

    return <CircularProgress color="secondary" size={72} thickness={2} />;
  }

  return (
    <Dialog fullScreen onClose={onClose} open={open} style={{ zIndex: 1400 }}>
      <Box className={classes.rootDialog}>
        {renderIconStatus()}

        <Box className={classes.titleDialog}>{textTitle}</Box>

        <Box className={classes.descriptionDialog}>{textDescription}</Box>
        {children}

        {(type === 'success' || type === 'error') && (
          <Box className={classes.wrapperButton}>
            <ButtonOutlined disableElevation onClick={onClose}>
              {t('common:buttons.close')}
            </ButtonOutlined>
          </Box>
        )}

        {notification && notification}
      </Box>
    </Dialog>
  );
}

DialogMessage.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'loading', 'error']),
  textTitle: PropTypes.string,
  textDescription: PropTypes.string,
  children: PropTypes.node,
  notification: PropTypes.node,
};

export default DialogMessage;
